import gameOfLifeImage from '../images/game_of_life.png';
import applicationTrackerImage from '../images/application_tracker2.png';
import pomodoroImage from '../images/pomodoro.png';
import dataVizImage from '../images/data_visualizer.png';
import qfqImage from '../images/qfq_brand.png';

/** @type {Array<{ id: string, link: string, technologies: string[], image: string, tags: string[] }>} */
export const projects = [
  {
    id: 'qfq',
    link: 'https://git.math.uzh.ch/typo3/qfq',
    technologies: ['PHP', 'TYPO3 Extension', 'JavaScript'],
    image: qfqImage,
    tags: ['backend', 'web'],
  },
  {
    id: 'applicationTracker',
    link: 'https://github.com/HollowWeb/Application-Tracker',
    technologies: ['React', 'Java Spring Boot', 'MySQL'],
    image: applicationTrackerImage,
    tags: ['fullstack', 'backend', 'web'],
  },
  {
    id: 'pomodoro',
    link: 'https://github.com/HollowWeb/Pomodoro',
    technologies: ['Python'],
    image: pomodoroImage,
    tags: ['scripting'],
  },
  {
    id: 'gameOfLife',
    link: 'https://github.com/HollowWeb/Game-of-life',
    technologies: ['Java'],
    image: gameOfLifeImage,
    tags: ['backend'],
  },
  {
    id: 'dataViz',
    link: 'https://github.com/HollowWeb/EnergyClimateDashboard',
    technologies: ['Python', 'CSV'],
    image: dataVizImage,
    tags: ['data', 'scripting'],
  },
];
